module.exports = __webpack_public_path__ + "img/sup_wallet_1.20845ea7.jpg";